import { APIProject } from '@cd3p/core/types/api';
import {
  hideProjectSensitiveFields,
  projectHasSensitiveData,
} from '@cd3p/core/utils/sensitiveData';
import { State } from 'modules';
import { userType as userTypeSelector } from 'selectors/app';

import { createSelector } from 'third-party';

export const customerProjectsItems = (state: State) =>
  state.customerProjects.items;
export const customerProjects = createSelector(
  [customerProjectsItems, userTypeSelector],
  (projects, userType) => {
    return projects.map((project: APIProject) =>
      projectHasSensitiveData(project, userType)
        ? hideProjectSensitiveFields(project)
        : project,
    );
  },
);
export const customerProjectsCount = (state: State) =>
  state.customerProjects.count;
export const customerProjectsLoaded = (state: State) =>
  state.customerProjects.customerProjectsLoaded;
export const customerProjectsSorting = (state: State) =>
  state.customerProjects.sorting;
export const showArchivedProjects = (state: State) =>
  state.customerProjects.filters.showArchived;
export const loadCustomerProjectsPending = (state: State) =>
  state.customerProjects.loadCustomerProjectsPending;
export const loadMoreCustomerProjectsPending = (state: State) =>
  state.customerProjects.loadMoreCustomerProjectsPending;
export const searchKeyword = (state: State) =>
  state.customerProjects.searchKeyword;
